import { render, staticRenderFns } from "./icon-reload.vue?vue&type=template&id=0b1c7a9f&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1c7a9f')) {
      api.createRecord('0b1c7a9f', component.options)
    } else {
      api.reload('0b1c7a9f', component.options)
    }
    module.hot.accept("./icon-reload.vue?vue&type=template&id=0b1c7a9f&", function () {
      api.rerender('0b1c7a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/icons/icon-reload.vue"
export default component.exports